//
//
//
//
//
//
//
//
//
//
//
//
//

import AQMonacoEditor from "@/components/Generics/AQMonacoEditor/AQMonacoEditor.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    name: "ViewAQMonacoEditor",
    components: {
        AQMonacoEditor,
        AQButton
    },
    data() {
        return {
            monacoData: "console.log('Test Monaco')\r\ntest\r\n"
        };
    },
    methods: {
        sendDataMonaco() {
            // eslint-disable-next-line
            console.log("DATA TEST MONACO DATA ==== ", this.monacoData);
        }
    }
};
